// @flow

import { createActions } from 'redux-actions';
import { MACHETE_NS } from './constants';

// Segmentation
const INIT = `${MACHETE_NS}/SEGMENTATION/INIT`;
const READY = `${MACHETE_NS}/SEGMENTATION/READY`;
const LOAD_NODES = `${MACHETE_NS}/SEGMENTATION/LOAD_NODES`;

const UPDATE_NODE = `${MACHETE_NS}/SEGMENTATION/UPDATE_NODE`;
const REMOVE_NODE = `${MACHETE_NS}/SEGMENTATION/REMOVE_NODE`;
const CREATE_WINDOW_PACKAGE = `${MACHETE_NS}/SEGMENTATION/CREATE_WINDOW_PACKAGE`;

const TOGGLE_SPLIT = `${MACHETE_NS}/SEGMENTATION/TOGGLE_SPLIT`;

const NODE_ADDED = `${MACHETE_NS}/SEGMENTATION/NODE_ADDED`;
const NODE_REMOVED = `${MACHETE_NS}/SEGMENTATION/NODE_REMOVED`;
const NODE_CHANGED = `${MACHETE_NS}/SEGMENTATION/NODE_CHANGED`;

const SET_POINTER_HIT = `${MACHETE_NS}/SEGMENTATION/SET_POINTER_HIT`;
const POINTER_DOWN = `${MACHETE_NS}/SEGMENTATION/POINTER_DOWN`;
const POINTER_UP = `${MACHETE_NS}/SEGMENTATION/POINTER_UP`;
const POINTER_MOVE = `${MACHETE_NS}/SEGMENTATION/POINTER_MOVE`;
const UPDATE_POINTER_CONFIG = `${MACHETE_NS}/SEGMENTATION/UPDATE_POINTER_CONFIG`;
const ENABLE_POINTER = `${MACHETE_NS}/SEGMENTATION/ENABLE_POINTER`;
const DISABLE_POINTER = `${MACHETE_NS}/SEGMENTATION/DISABLE_POINTER`;

const ADD_NODE_SELECTION = `${MACHETE_NS}/SEGMENTATION/ADD_NODE_SELECTION`;
const REMOVE_NODE_SELECTION = `${MACHETE_NS}/SEGMENTATION/REMOVE_NODE_SELECTION`;
const SET_NODE_SELECTION = `${MACHETE_NS}/SEGMENTATION/SET_NODE_SELECTION`;
const CLEAR_NODE_SELECTION = `${MACHETE_NS}/SEGMENTATION/CLEAR_NODE_SELECTION`;

const BEGIN_OPERATION = `${MACHETE_NS}/SEGMENTATION/BEGIN_OPERATION`;
const ADD_OPERATION_POINT = `${MACHETE_NS}/SEGMENTATION/ADD_OPERATION_POINT`;
const CLEAR_OPERATION = `${MACHETE_NS}/SEGMENTATION/CLEAR_OPERATION`;

const TEARDOWN = `${MACHETE_NS}/SEGMENTATION/TEARDOWN`;

const forceArray = (input) => (Array.isArray(input) ? input : [input]);

const actions = createActions({
  [INIT]: (order, opts = {}) => ({ order, opts }),
  [READY]: () => null,
  [LOAD_NODES]: (nodes) => ({ nodes }),
  [UPDATE_NODE]: (nodes, properties) => ({ nodes, properties }),
  [CREATE_WINDOW_PACKAGE]: (parentId, properties) => ({ parentId, properties }),
  [REMOVE_NODE]: (uuid) => ({ uuid }),
  [TOGGLE_SPLIT]: (uuid) => ({ uuid }),
  [NODE_ADDED]: (node) => ({ node }),
  [NODE_REMOVED]: (node, parentNode) => ({ node, parentNode }),
  [NODE_CHANGED]: (uuid, type, properties) => ({ uuid, type, properties }),
  [SET_POINTER_HIT]: (hit) => ({ hit }),
  [POINTER_DOWN]: (event, hit) => ({ event, hit }),
  [POINTER_UP]: (event, hit) => ({ event, hit }),
  [POINTER_MOVE]: (event, hit) => ({ event, hit }),
  [UPDATE_POINTER_CONFIG]: (updater) => ({ updater }),
  [DISABLE_POINTER]: () => null,
  [ENABLE_POINTER]: () => null,
  [ADD_NODE_SELECTION]: (uuids) => ({ uuids: forceArray(uuids) }),
  [REMOVE_NODE_SELECTION]: (uuids) => ({ uuids: forceArray(uuids) }),
  [SET_NODE_SELECTION]: (uuids) => ({ uuids: forceArray(uuids) }),
  [CLEAR_NODE_SELECTION]: () => null,
  [BEGIN_OPERATION]: (parentId, firstPoint) => ({ parentId, firstPoint }),
  [ADD_OPERATION_POINT]: (point) => ({ point }),
  [CLEAR_OPERATION]: () => null,
  [TEARDOWN]: () => null,
});

export default actions.machete.segmentation;
